import { z } from 'zod'
import { PAGE_RENDERED_EVENT_NAME } from '../../validation/enums'

export const WebPageDetailsSchema = z.object({
  webPageDetails: z.object({
    name: z.string().min(1, { message: 'webPageDetails.name cannot be empty' }),
    pageViews: z.object({ value: z.number() }),
    isErrorPage: z.boolean().optional(),
  }),
})

export const WebInteractionSchema = z.object({
  webInteraction: z.object({
    name: z.string().nullable(),
    type: z.string().nullable().optional(),
    url: z.string().nullable().optional(),
    linkClicks: z.object({ value: z.number() }),
  }),
})

// Main Schema Validation
export const createADLSchemaValidation = (eventName: string) =>
  z
    .object({
      event: z.string(),
      web: eventName === PAGE_RENDERED_EVENT_NAME ? WebPageDetailsSchema : WebInteractionSchema,
    })
    .passthrough()
